(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameDeleteController',LastNameDeleteController);

    LastNameDeleteController.$inject = ['$uibModalInstance', 'entity', 'LastName'];

    function LastNameDeleteController($uibModalInstance, entity, LastName) {
        var vm = this;
        vm.lastName = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LastName.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
